import z from 'zod';
export const AlgoliaAppId = z.string().parse(process.env.ALGOLIA_APP_ID);
export const AlgoliaAPIKey = z.string().parse(process.env.ALGOLIA_API_KEY);
export const AlgoliaAnalyticsKey = z
  .string()
  .parse(process.env.ALGOLIA_API_ANALYTICS_KEY);
export const AlgoliaRecipeIndex = z
  .string()
  .parse(process.env.ALGOLIA_RECIPE_INDEX);
export const AlgoliaGroceryIndex = z
  .string()
  .parse(process.env.ALGOLIA_PRODUCT_INDEX);

export type AlgoliaIndexNames =
  | typeof AlgoliaRecipeIndex
  | typeof AlgoliaGroceryIndex;
